var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1100,
    height: 433,
    viewBox: "0 0 1100 433",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.6 367.2C284.999 367.2 367.2 284.999 367.2 183.6C367.2 82.2005 284.999 0 183.6 0C82.2005 0 0 82.2005 0 183.6C0 284.999 82.2005 367.2 183.6 367.2Z",
    fill: "#6786BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.8 115.5H392V251.7H1099.8V115.5Z",
    fill: "#6786BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.9 115.429V432.529H989.2V115.429H857.9Z",
    fill: "#6786BE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.640fcf7d6a5998e525db1dfb2b0895bc.svg";
export { ForwardRef as ReactComponent };